// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Button from "./Button.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function FilterButton(props) {
  var onFilterClick = props.onFilterClick;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("button", {
                    children: JsxRuntime.jsx("img", {
                          className: "h-4 w-4 block mx-auto",
                          alt: "search",
                          src: "/images/icon-filter.svg"
                        }),
                    className: Cn.make([
                          Button.redCircleStyle,
                          "sm:hidden flex items-center content-center h-12 w-12 ml-3"
                        ]),
                    onClick: (function (param) {
                        Belt_Option.mapWithDefault(onFilterClick, undefined, (function (click) {
                                Curry._1(click, undefined);
                              }));
                      })
                  }),
              className: Belt_Option.getWithDefault(props.className, "")
            });
}

var make = FilterButton;

export {
  make ,
}
/* Button Not a pure module */
